import { render, staticRenderFns } from "./ExcelQuestionImporter.vue?vue&type=template&id=74e1dfdc&scoped=true"
import script from "./ExcelQuestionImporter.vue?vue&type=script&lang=js"
export * from "./ExcelQuestionImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1dfdc",
  null
  
)

export default component.exports